export const headerDetails = {
  namespaced: true,
  state: {

  },
  getters: {
    
  },
  actions: {
    
  },
  mutations: {
    
  },
};
